import DOMPurify from 'dompurify'
import {Marked, Renderer, type TokenizerObject} from 'marked'

const markdownRenderer = new Renderer()
const markdownTokenizer: TokenizerObject = {
  del(_src, _maskedSrc, _prevChar) {
    return undefined
  },
}
const markdownParser = new Marked({
  gfm: true,
  breaks: true,
  renderer: markdownRenderer,
  tokenizer: markdownTokenizer,
})

const escapeHtml = (text: string) =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

markdownRenderer.codespan = ({text}) => escapeHtml(text)

markdownRenderer.code = ({text}) => `<p>${escapeHtml(text).replace(/\n/g, '<br />')}</p>`

const stripFrontMatter = (text: string) => text.replace(/^\uFEFF?---\s*\n[\s\S]*?\n---\s*(?:\n|$)/, '')

export const renderAssistantMarkdown = (content: string): string => {
  const markdownText = stripFrontMatter(content)
  const markdownHtml = markdownParser.parse(markdownText, {async: false}) as string
  return DOMPurify.sanitize(markdownHtml)
}
